interface PayloadStorage {
  value: {
    ip: string;
    city: string;
    region: string;
    region_code: string;
    country_code: string;
    country_code_iso3: string;
    country_name: string;
    country_capital: string;
    country_tld: string;
    continent_code: string;
    in_eu: boolean;
    postal: string;
    latitude: number;
    longitude: number;
    timezone: string;
    utc_offset: string;
    country_calling_code: string;
    currency: string;
    currency_name: string;
    languages: string;
    asn: string;
    org: string;
  };
  timestamp: number;
}

const cacheKey = 'geoCache';

export async function getGeo(): Promise<PayloadStorage['value'] | null> {
  try {
    const cached = localStorage.getItem(cacheKey);

    if (cached) {
      const data = JSON.parse(cached) as PayloadStorage;

      if (Date.now() - data.timestamp < 24 * 60 * 60 * 1000) {
        return data.value;
      }
    }

    const res = await fetch('https://ipapi.co/json/').catch(() => null);

    if (!res) return null;

    const json = await res.json();

    localStorage.setItem(
      cacheKey,
      JSON.stringify({
        value: json,
        timestamp: Date.now(),
      }),
    );

    return json;
  } catch {
    localStorage.setItem(
      cacheKey,
      JSON.stringify({
        value: null,
        timestamp: Date.now(),
      }),
    );
    return null;
  }
}
